/**
 * @param preferenceCenter {HTMLElement}
 * @return {HTMLInputElement}
 */
module.exports = function getPreferenceCenterPhoneNumberInput(preferenceCenter) {
    const phoneNumber = preferenceCenter.querySelector('[name="phoneNumber"]');

    if (phoneNumber instanceof HTMLInputElement) {
        return phoneNumber;
    }

    alert("Something went wrong!");
    throw new Error("getPreferenceCenterPhoneNumber: Phone number does not exist in preference center!");
}
